import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

export class AdmissionCoordinatorField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            showDropdown: false,
            hoveredKey: null,
        };
        this.state.searchText =
            this.resolveNameFromId(props.coordinatorId) || '';
    }

    getFullCoordinatorList = () => {
        return [
            ...(this.props.coordinatorArray || []),
            ...(this.props.extraCoordinators || []),
        ];
    };

    componentDidUpdate(prevProps) {
        if (
            this.props.coordinatorId !== prevProps.coordinatorId &&
            String(this.props.coordinatorId || '') !==
                String(this.resolveIdFromName(this.state.searchText) || '')
        ) {
            const resolvedName = this.resolveNameFromId(
                this.props.coordinatorId
            );
            // A brand-new coordinator (just created via "Create New
            // Coordinator") may not be in coordinatorArray/extraCoordinators
            // yet on this exact render - don't blank out the name in that case.
            if (resolvedName !== '') {
                this.setState({ searchText: resolvedName });
            }
        }
    }

    resolveNameFromId = (coordinatorId) => {
        if (coordinatorId === undefined || coordinatorId === '') {
            return '';
        }
        const match = this.getFullCoordinatorList().find(
            (item) => String(item.coordinator_id) === String(coordinatorId)
        );
        return match ? match.label : '';
    };

    resolveIdFromName = (name) => {
        const match = this.getFullCoordinatorList().find(
            (item) => item.label === name
        );
        return match ? match.coordinator_id : undefined;
    };

    handleInputChange = (event) => {
        this.setState({ searchText: event.target.value, showDropdown: true });
    };

    handleInputFocus = () => {
        if (this.blurTimeoutId) {
            clearTimeout(this.blurTimeoutId);
            this.blurTimeoutId = null;
        }
        this.setState({ showDropdown: true });
    };

    handleInputBlur = () => {
        this.blurTimeoutId = setTimeout(() => {
            this.setState({ showDropdown: false });
        }, 150);
    };

    componentWillUnmount() {
        if (this.blurTimeoutId) {
            clearTimeout(this.blurTimeoutId);
        }
    }

    handleSelect = (item) => {
        this.setState({ searchText: item.label, showDropdown: false });
        this.props.onSelect({ id: item.coordinator_id, name: item.label });
    };

    openCreateCoordinator = () => {
        this.setState({ showDropdown: false });
        this.props.onOpenCreateCoordinator(this.state.searchText);
    };

    filteredList = () => {
        const list = this.getFullCoordinatorList();
        const text = this.state.searchText.trim().toLowerCase();
        if (text === '') {
            return list;
        }
        return list.filter((item) =>
            String(item.label).toLowerCase().includes(text)
        );
    };

    render() {
        const list = this.filteredList();
        const searchTextTrimmed = this.state.searchText.trim().toLowerCase();
        const dropdownHeight = Math.min(
            200,
            Math.max(40, list.length * 32 + 8)
        );
        return (
            <div className='row grid-row-group'>
                <div className='col-lg-12 detail_search'>
                    <label className='pl-5'>ADMISSION COORDINATOR</label>
                    <>
                        <div className='d-flex'>
                            <div className='filter'>
                                <input
                                    className={
                                        this.props.hasError
                                            ? 'form-control error-field'
                                            : 'form-control'
                                    }
                                    value={this.state.searchText}
                                    placeholder='Search Admission Coordinator'
                                    type='text'
                                    onChange={this.handleInputChange}
                                    onFocus={this.handleInputFocus}
                                    onBlur={this.handleInputBlur}
                                />
                                <i className='fa-regular fa-magnifying-glass' />
                                {this.state.showDropdown ? (
                                    <div
                                        className='patient_dropdown'
                                        style={{
                                            height: `${dropdownHeight}px`,
                                            overflow: 'hidden',
                                            border: '1px solid #00233A',
                                            borderTop: 'none',
                                            borderRadius: '0 0 6px 6px',
                                            boxSizing: 'border-box',
                                        }}
                                    >
                                        <ul
                                            style={{
                                                listStyleType: 'none',
                                                paddingLeft: 0,
                                                margin: 0,
                                                height: `${dropdownHeight}px`,
                                                overflowY: 'auto',
                                                boxSizing: 'border-box',
                                            }}
                                        >
                                            {list.length > 0 ? (
                                                list.map((item, index) => {
                                                    let res = item.label;
                                                    if (searchTextTrimmed) {
                                                        res = res.replace(
                                                            new RegExp(
                                                                `(${searchTextTrimmed})`,
                                                                'i'
                                                            ),
                                                            (match) =>
                                                                `<b class='highlight'>${match}</b>`
                                                        );
                                                    }
                                                    const itemKey =
                                                        item.coordinator_id ??
                                                        index;
                                                    return (
                                                        <li
                                                            key={itemKey}
                                                            onMouseDown={() =>
                                                                this.handleSelect(
                                                                    item
                                                                )
                                                            }
                                                            onMouseEnter={() =>
                                                                this.setState({
                                                                    hoveredKey:
                                                                        itemKey,
                                                                })
                                                            }
                                                            onMouseLeave={() =>
                                                                this.setState({
                                                                    hoveredKey:
                                                                        null,
                                                                })
                                                            }
                                                            style={{
                                                                cursor: 'pointer',
                                                                padding:
                                                                    '5px 10px',
                                                                borderBottom:
                                                                    '1px solid #E5EAEE',
                                                                backgroundColor:
                                                                    this.state
                                                                        .hoveredKey ===
                                                                    itemKey
                                                                        ? '#eef0f8'
                                                                        : undefined,
                                                            }}
                                                        >
                                                            <div className='patient_autocomplete'>
                                                                <div>
                                                                    <div className='patient_no_name'>
                                                                        <span
                                                                            className='first_name'
                                                                            // eslint-disable-next-line react/no-danger
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: res,
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    );
                                                })
                                            ) : (
                                                <div
                                                    style={{
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    No Records Found
                                                </div>
                                            )}
                                        </ul>
                                    </div>
                                ) : null}
                            </div>
                            <div
                                className='plus'
                                onClick={this.openCreateCoordinator}
                            >
                                <span>
                                    <i
                                        className='fa-regular fa-plus'
                                        aria-hidden='true'
                                    />
                                </span>
                            </div>
                        </div>
                        {this.props.hasError ? (
                            <p className='error m-0' style={{ color: 'red' }}>
                                Admission Coordinator is required.
                            </p>
                        ) : null}
                    </>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        coordinatorArray: state.search.deletedPage.coordinatorArray,
    };
};

export default connect(mapStateToProps)(withRouter(AdmissionCoordinatorField));
